import { Box, Grid } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import { getBranch } from 'utils/app.utils'

/** COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputSecondNewDatePicker, { PICKER_VIEWS } from 'component/Input/InputSecondNewDatePicker'
import Loading from 'component/Loading'
import RemittanceList from './remittanceSecondList'

/** STYLE */
import { notiError } from 'component/notifications/notifications'
import FunctionPrint from 'component/Print/print'
import * as UseStyled from 'features/report/useStyled'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import { ExportToExcelSecond } from './exportToExcel'


export default function RemittanceSecond() {
  const { t } = useTranslation()
  const history = useHistory()
  const componentRef = useRef<HTMLDivElement>(null)
  const momentNow = moment().format('YYYY-MM-DD')

  const [branchId, setBranchId] = useState<any>(getBranch())
  const [branches, setBranches] = useState<any[]>([])
  const [rowCount, setRowCount] = useState<number>(0)
  const [sortBy, setSortBy] = useState<string>('createAt')
  const [sortType, setSortType] = useState<string>('ASC')
  const [loading, setLoading] = useState<boolean>(false)

  const [remittanceData, getRemittanceData] = useState<any[]>([])
  const [remittanceDate, setRemittanceDate] = useState<string>(momentNow)
  const [remittancePage, setRemittancePage] = useState<number>(1)
  const [remittanceLimitPage, setRemittanceLimitPage] = useState<number>(10)

  const [checkDF, setCheckDf] = useState<boolean>(true)
  const [checkCash, setCheckCash] = useState<boolean>(false)

  const [checkTreatmentRight, setCheckTreatmentRight] = useState<boolean>(true)

  const verifyPermission = async () => {
    const condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 200
    }
    ReportApi.reportList(condition).then(({ data }) => {
      const check = _.find(data, (val: any) => String(val.reportKey) === 'REMITTANCE_SECOND') ? true : false
      if (!check) {
        history.push(routeName.report)
        return false
      }
    })

    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(data))
      .catch((e) => {
        return
      })

    return true
  }

  useEffect(() => {
    verifyPermission()
  }, [])

  const loadRemittance = async (pageArg: number) => {
    setLoading(true)
    try {
      let condition: any = {
        page: remittancePage,
        pageLimit: remittanceLimitPage,
        branchId: branchId,
        date: remittanceDate,
        isOpeartive: 1
      }
      if (sortType) condition = { ...condition, sortType: sortType }
      if (sortBy) condition = { ...condition, sortBy: sortBy }
      if (checkDF) condition = { ...condition, df: checkDF === true ? 1 : 0 }
      if (checkTreatmentRight) condition = { ...condition, treatmentRight: checkTreatmentRight === true ? 1 : 0 }
      if (remittanceDate !== null) condition = { ...condition, date: remittanceDate }
      const { headers, data } = await ReportApi.reportRemittance(condition)
      getRemittanceData(data)
      setRowCount(Number(headers['x-total'] || 0))
    } catch (err) {
      notiError(t('ERROR'))
      setLoading(false)
    }
    finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    loadRemittance(remittancePage)
  }, [remittancePage, remittanceLimitPage, sortBy, sortType])

  const filter = [branchId === 0 ? `${t(`REPORT.FILTER.ALL`)}` : `${_.get(_.find(branches, { branchId: branchId }), 'branchName') || _.get(_.find(branches, { branchId: branchId }), 'branchNameEn')}`, remittanceDate]

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangeRowsPerPage = (limit: number) => setRemittanceLimitPage(limit)

  const handleChangePage = (val: number) => setRemittancePage(val)

  const handleExport = () => {
    if (!remittanceData) return
    const report: any = remittanceData
    report.branchName = filter[0] || ''
    report.date = filter[1] || ''
    report.t = t
    ExportToExcelSecond(report)
  }
  return (
    <Box>
      <HeaderCard text={t('REPORT.REPORT_NAME.REMITTANCE_SECOND')} />
      <Box px={3} pt={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              label={t('REPORT.FILTER.BRANCH')}
              value={branchId}
              onChange={e => setBranchId(Number(e.target.value))}
              options={[
                ...branches.map(b => ({ value: b.branchId, name: b.branchName || b.branchNameEn }))
              ]}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <InputSecondNewDatePicker
              dateFormat={"DD/MM/YYYY"}
              placeholder={t('REPORT.FILTER.DATE')}
              label={''}
              inputHeight={40}
              value={remittanceDate}
              onchange={(e: any) => {
                setRemittanceDate(moment(e).format('YYYY-MM-DD'))
                setRemittancePage(1)
              }}
              views={PICKER_VIEWS.DAY || PICKER_VIEWS.MONTH || PICKER_VIEWS.YEAR}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
              <MainButton
                title={t('INPUT.SEARCH')}
                type="primary"
                variant="contained"
                style={{ width: '120px' }}
                onClick={loadRemittance}
              />
              <UseStyled.DropdownDocument>
                <Dropdown.Toggle id="dropdown-basic" className="ml-xl-auto">
                  {t('REGISTER.BUTTON.PRINT_DOCUMENT')}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={handleExport}>{t('Excel')}</Dropdown.Item>
                  <FunctionPrint
                    content={() => componentRef.current}
                    removeIfram
                    trigger={() => <Dropdown.Item>{t('PDF')}</Dropdown.Item>}
                    style={`@page { size: 793.7007874px 1122.519685px;  margin: 0.5cm; } @media print { body { -webkit-print-color-adjust: exact; }`}
                  />
                </Dropdown.Menu>
              </UseStyled.DropdownDocument>
            </Box>
          </Grid>
        </Grid>
        <Box className={'mt-3 pl-xl-2 pr-xl-2 pb-4'}>
          <RemittanceList
            page={remittancePage}
            pageLimit={remittanceLimitPage}
            rowCount={rowCount}
            sortBy={sortBy}
            sortType={sortType}
            data={remittanceData}
            onRequestSort={onRequestSort}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            componentRef={componentRef}
            cash={checkCash}
            treatmentRight={checkTreatmentRight}
            df={checkDF}
            filter={filter}
          />
        </Box>
      </Box>
      <Loading show={loading} type="fullLoading" />
    </Box>
  )
}
